import React from 'react'
import useDispatchEta from 'components/Dispatch/useDispatchEta'
import { Label } from 'components/primitives'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useTranslation } from 'react-i18next'

export const DispatchAAAETA = ({ service }) => {
  const { t } = useTranslation()
  const { roadsideIsAaaHookActive } = useFlags()
  const { dispatchEta } = useDispatchEta(service, roadsideIsAaaHookActive)

  return <Label style={{ alignSelf: 'center' }}>{`${t('labels.eta')} : ${dispatchEta ? dispatchEta : t('N/A')}`}</Label>
}
